import { createNetworkActions } from "~/utils/actions";

export default {
	...createNetworkActions("BANK_ACCOUNTS"),
};
